export default {
  "hierarchy": {},
  "props": {
    "default": {
      "selectIcon": "fa fa-chevron-down"
    }
  }
}